/** * 主界面中心组件 * 创建时间：2017-02-22 * 创建人：zhanlz */
<template>
	<div>
		<div class="row content-tabs">
			<button class="roll-nav roll-left J_tabLeft" @click="scrollLeft"><i class="fa fa-backward"></i></button>
			<nav class="page-tabs J_menuTabs">
				<div class="page-tabs-content" ref="navBox">
					<transition-group name="list"
	                    		v-on:enter="enter"
	                    		>
	                <a v-bind:key="index + 'tab'" href="javascript:;" class="J_menuTab" :class="{active:currentIndex==tab.No}" ref="profile" v-for="(tab,index) in tabList" @click="goTab(tab,index)">{{tab.name}}
							<i class="fa fa-times-circle" v-show="tab.No=='vehicleMonitor' ?'':closeBtn" @click.stop.prevent="closeTab(tab,index)"></i>
					</a>
	                </transition-group>
				</div>
			</nav>
			<button class="roll-nav roll-right J_tabRight" @click="scrollRight"><i class="fa fa-forward"></i>
	                </button>
			<div class="btn-group roll-nav roll-right">
				<button class="dropdown J_tabClose" data-toggle="dropdown">关闭操作<span class="caret"></span>

	                    </button>
				<ul role="menu" class="dropdown-menu dropdown-menu-right">
					<!--<li class="J_tabShowActive">
						<a>定位当前选项卡</a>
					</li>
					<li class="divider"></li>-->
					<li class="J_tabCloseAll" @click="closeAllTabs()">
						<a>关闭全部选项卡</a>
					</li>
					<li class="J_tabCloseOther" @click="closeOtherTabs()">
						<a>关闭其他选项卡</a>
					</li>
				</ul>
			</div>
			<a class="roll-nav roll-right J_tabExit" @click="confirmLoginOut"><i class="fa fa fa-sign-out"></i> 退出</a>
		</div>
		<!--页面tab弹框组件开始-->
		<main-modal ref="modalConfirm" class="ensure" size="small" title="提示" >
			<p v-text="confirmContent"></p>
			<div slot="footer">
				<button class="btn btn-primary" @click="closeConfirm">取消</button>
				<button class="btn btn-primary" @click="loginOut">确定</button>
			</div>
		</main-modal>
		<!--页面tab弹框组件开始-->
		<main-modal ref="modalTip" size="small" title="提示" >
			<p v-text="tipContent"></p>
			<div slot="footer">
				<button class="btn btn-primary" @click="closetip">关闭</button>
			</div>
		</main-modal>
	</div>

</template>

<script>
	import {mapState} from 'vuex'
	import MainModal from 'components/common/MainModal'
	import { LOGINOUT_ENSURE, LOGINOUT_EXCEPTION } from 'static/message'

	export default {
	  name: 'ContentNav',
	  components: {
	    MainModal
	  },
	  data () {
	    return {
	      closeBtn: true,
	      tabOuterWidth: '',      // 可视区域非tab宽度
	      visibleWidth: '',	   // 可视区域tab宽度
	      tipContent: '',
	      confirmContent: LOGINOUT_ENSURE
	    }
	  },
	  updated () {
	    this.tabOuterWidth = this.calSumWidth($('.content-tabs').children().not('.J_menuTabs'))
	    this.visibleWidth = $('.content-tabs').outerWidth(true) - this.tabOuterWidth
	//    console.log(this.marginLeftVal + ',' + this.tabOuterWidth + ',' + this.visibleWidth)
	  },
	  computed: {
	    marginLeftVal () {
	      return this.scrollValue
	    },
	    ...mapState({
	      tabList: state => state.home.tabList,
	      currentIndex: state => state.home.currentIndex,
	      path: state => state.home.path,
	      scrollValue: state => state.home.scrollValue
	    })
	  },
	  watch: {
	    currentIndex: function () {
	      const child = this.$refs.profile
	      const len = this.tabList.length
	      const cLen = child.length
	      if (cLen == len) {
	        let index = 0
	        for (let i = 0, length = this.tabList.length; i < length; i++) {
	          if (this.tabList[i].No == this.currentIndex) {
	            index = i
	          }
	        }
	        this.scrollToTab(child[index])
	      }
	    }
	  },
	  mounted () {
	    const oDiv = this.$refs.navBox
	    oDiv.style.marginLeft = 0 - this.scrollValue + 'px'
	  },
	  destroyed () {
	    this.$store.dispatch('closeAlarmNum')
	  },
	  methods: {
	    goTab: function (obj, index) {
				 if (obj.id == 'PageRescueDriverEdit') {
	            	this.$store.dispatch('setorderstatus')
 }
	      this.$store.dispatch('goTab', obj)
	      this.$router.push(this.path)
	      const child = this.$refs.profile
	      this.scrollToTab(child[index])
	    },
	    closeTab: function (obj, index) {
	      this.$store.dispatch('closeTab', index)
	      this.$router.push(this.path)
	      const child = this.$refs.profile
	      this.scrollToTab(child[index])
	    },
	    closeAllTabs: function () { // 关闭全部选项卡（即关闭除首页以外的所有选项卡，页面跳转到首页组件）
	      this.$store.dispatch('closeAllTabs')
	      this.$router.push(this.path)
	      const child = this.$refs.profile
	      this.scrollToTab(child[0])
	    },
	    closeOtherTabs: function () { // 关闭其他选项卡（即关闭除首页和当前选中页的tab,页面保持在当前组件）
	      this.$store.dispatch('closeOtherTabs')
	      const child = this.$refs.profile
	      this.scrollToTab(child[0])
	  	},
		  	enter: function (el, done) {
		  		this.scrollToTab(el)
	  		done()
	  	},
		  	scrollToTab: function (element) {
		  		const marginLeftVal = this.calSumWidth($(element).prevAll()), marginRightVal = this.calSumWidth($(element).nextAll())
	        // 实际滚动宽度
	    let scrollVal = 0
	    if ($('.page-tabs-content').outerWidth() < this.visibleWidth) {
		            scrollVal = 0
	    } else if (marginRightVal <= (this.visibleWidth - $(element).outerWidth(true) - $(element).next().outerWidth(true))) {
		            if ((this.visibleWidth - $(element).next().outerWidth(true)) > marginRightVal) {
		                scrollVal = marginLeftVal
	              let tabElement = element
	              while ((scrollVal - $(tabElement).outerWidth()) > ($('.page-tabs-content').outerWidth() - this.visibleWidth)) {
		                    scrollVal -= $(tabElement).prev().outerWidth()
	                tabElement = $(tabElement).prev()
	              }
		            }
		        } else if (marginLeftVal > (this.visibleWidth - $(element).outerWidth(true) - $(element).prev().outerWidth(true))) {
		            scrollVal = marginLeftVal - $(element).prev().outerWidth(true)
	        }
		        this.$store.dispatch('getScrollVal', scrollVal)
	    $('.page-tabs-content').animate({
		            marginLeft: 0 - this.scrollValue + 'px'
		        }, 'fast')
	  	},
		  	calSumWidth: function (elements) {
		  		let width = 0
	    $(elements).each(function () {
		            width += $(this).outerWidth(true)
	    })
	    return width
	  	},
		  	scrollLeft: function () {
		        // 实际滚动宽度
		        var scrollVal = 0
	    if ($('.page-tabs-content').width() < this.visibleWidth) {
		            return false
	    } else {
		            var tabElement = $('.J_menuTab:first')
	      var offsetVal = 0
	      while ((offsetVal + $(tabElement).outerWidth(true)) <= this.marginLeftVal) { // 找到离当前tab最近的元素
		                offsetVal += $(tabElement).outerWidth(true)
	        tabElement = $(tabElement).next()
	      }
		            offsetVal = 0
	      if (this.calSumWidth($(tabElement).prevAll()) > this.visibleWidth) {
		                while ((offsetVal + $(tabElement).outerWidth(true)) < (this.visibleWidth) && tabElement.length > 0) {
		                    offsetVal += $(tabElement).outerWidth(true)
	                  tabElement = $(tabElement).prev()
	                }
		                scrollVal = this.calSumWidth($(tabElement).prevAll())
	      }
		        }
		        this.$store.dispatch('getScrollVal', scrollVal)
	    $('.page-tabs-content').animate({
		            marginLeft: 0 - scrollVal + 'px'
		        }, 'fast')
	  	},
		  	scrollRight: function () {
		        // 实际滚动宽度
		        var scrollVal = 0
	    if ($('.page-tabs-content').width() < this.visibleWidth) {
		            return false
	    } else {
		            var tabElement = $('.J_menuTab:first')
	      var offsetVal = 0
	      while ((offsetVal + $(tabElement).outerWidth(true)) <= this.marginLeftVal) { // 找到离当前tab最近的元素
		                offsetVal += $(tabElement).outerWidth(true)
	        tabElement = $(tabElement).next()
	      }
		            offsetVal = 0
	      while ((offsetVal + $(tabElement).outerWidth(true)) < (this.visibleWidth) && tabElement.length > 0) {
		                offsetVal += $(tabElement).outerWidth(true)
	        tabElement = $(tabElement).next()
	      }
		            scrollVal = this.calSumWidth($(tabElement).prevAll())
	      this.$store.dispatch('getScrollVal', scrollVal)
	      if (scrollVal > 0) {
		                $('.page-tabs-content').animate({
		                    marginLeft: 0 - scrollVal + 'px'
		                }, 'fast')
	      }
		        }
		  	},
		  	loginOut () {
		  		this.$refs.modalConfirm.close()
	  		this.$http.post(process.env.API_ROOT + '/account/logout')
	    		.then((response) => {
	      if (response.body.status === 200) {
	        this.clearStorage()
	        this.$router.push('login')
	        this.$store.dispatch('closeAlarmNum')// 清空报警数据轮巡
	        this.$store.dispatch('savePageStyle', 2)// 初始化界面布局数据
	        this.$store.dispatch('removepermission')
	      } else {
	        this.opentip(LOGINOUT_EXCEPTION)
	        this.clearStorage()
	      }
    }, (response) => {
	      this.opentip(LOGINOUT_EXCEPTION)
	      this.clearStorage()
	    })
	    		.catch((response) => {
	      this.opentip(LOGINOUT_EXCEPTION)
	      this.clearStorage()
	    })
		  	},
		  	clearStorage () {
		  		this.$store.dispatch('removeall')
	    this.$store.dispatch('removestorage')
	    this.closeTokenTimer()
	  	},
		  	confirmLoginOut () {
	    this.$refs.modalConfirm.open()
	  },
	    closeConfirm () {
	      this.$refs.modalConfirm.close()
	    },
	    opentip (message) {
	      this.tipContent = message
	      this.$refs.modalTip.open()
	    },
	    closetip () {
	      this.$refs.modalTip.close()
	    },
	    closeTokenTimer () {
	      let timerName = this.$store.state.user.tokentimer
	      clearInterval(timerName)
	    }
	  }

	}
</script>

<style>

</style>



// WEBPACK FOOTER //
// ContentNav.vue?d0137a3e